import ReactGa from "react-ga";

ReactGa.initialize("UA-174281096-1");

export default ReactGa;
